"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _styles = require("@material-ui/core/styles");

var _elements = require("../../elements");

var _Grid = _interopRequireDefault(require("../../elements/Grid"));

var _Confirmation = _interopRequireDefault(require("./Confirmation.css"));

var _utils = require("../../utils");

var Confirmation =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Confirmation, _React$PureComponent);

  function Confirmation() {
    (0, _classCallCheck2.default)(this, Confirmation);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Confirmation).apply(this, arguments));
  }

  (0, _createClass2.default)(Confirmation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          open = _this$props.open,
          onConfirm = _this$props.onConfirm,
          onCancel = _this$props.onCancel,
          title = _this$props.title,
          hasCheckbox = _this$props.hasCheckbox,
          checkboxChecked = _this$props.checkboxChecked,
          checkboxText = _this$props.checkboxText,
          onCheckboxToggle = _this$props.onCheckboxToggle,
          confirmButtonLabel = _this$props.confirmButtonLabel,
          cancelButtonLabel = _this$props.cancelButtonLabel,
          classes = _this$props.classes;
      return React.createElement(_Dialog.default, {
        open: open,
        PaperProps: {
          classes: {
            root: classes.root
          }
        },
        "aria-labelledby": "confirmation-dialog-title",
        "aria-describedby": "confirmation-dialog-description",
        disableBackdropClick: true,
        disableEscapeKeyDown: true
      }, React.createElement(_DialogTitle.default, {
        id: "confirmation-dialog-title",
        classes: {
          root: classes.title
        }
      }, (0, _utils.isTextContent)(title) ? React.createElement(_elements.Typography, {
        variant: "dialogHeader"
      }, title) : title), React.createElement(_DialogContent.default, {
        classes: {
          root: classes.content
        }
      }, React.createElement(_elements.Typography, {
        variant: "dialogContent"
      }, children)), React.createElement(_DialogActions.default, {
        classes: {
          root: classes.actions
        }
      }, React.createElement(_Grid.default, {
        container: true,
        justify: "space-between",
        spacing: 0
      }, hasCheckbox && React.createElement(_Grid.default, {
        item: true,
        xs: 6
      }, React.createElement(_elements.Checkbox, {
        checked: checkboxChecked,
        onChange: onCheckboxToggle,
        label: checkboxText,
        className: classes.checkbox
      })), !hasCheckbox && React.createElement(_Grid.default, {
        item: true,
        xs: 6
      }), React.createElement(_Grid.default, {
        container: true,
        justify: "flex-end",
        item: true,
        xs: 6
      }, React.createElement(_elements.Button, {
        onClick: onConfirm,
        type: "primary"
      }, confirmButtonLabel), React.createElement(_elements.Button, {
        onClick: onCancel,
        type: "tertiary"
      }, cancelButtonLabel)))));
    }
  }]);
  return Confirmation;
}(React.PureComponent);

Confirmation.defaultProps = {
  confirmButtonLabel: 'Confirm',
  cancelButtonLabel: 'Cancel',
  checkboxText: "Don't show this again"
};
Confirmation.propTypes = {
  /**
   * Whether the modal is showing or not. True = showing.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Action taken when the confirm button is clicked.
   */
  onConfirm: PropTypes.func.isRequired,

  /**
   * Action taken when the cancel button is clicked.
   */
  onCancel: PropTypes.func.isRequired,

  /**
   * Whether a checkbox appears in the modal or not.
   */
  hasCheckbox: PropTypes.bool.isRequired,

  /**
   * Whether the checkbox is checked or not.
   */
  checkboxChecked: PropTypes.bool,

  /**
   * Text that describes the purpose of the checkbox.
   */
  checkboxText: PropTypes.string,

  /**
   * Action taken when the checkbox is clicked/unclicked.
   */
  onCheckboxToggle: PropTypes.func,

  /**
   * Title of the modal.
   */
  title: PropTypes.node.isRequired,

  /**
   * Content displayed in the body of the modal.
   */
  children: PropTypes.node.isRequired,

  /**
   * Label inside the confirm button.
   */
  confirmButtonLabel: PropTypes.node,

  /**
   * Label inside the cancel button.
   */
  cancelButtonLabel: PropTypes.node
};

var _default = (0, _styles.withStyles)(_Confirmation.default)(Confirmation);

exports.default = _default;